import axios from 'axios';
import { loginreq, req } from './axiosFun';
import {getStore} from "../utils/util";

var qz="";
// 获取用户菜单
export const prodList = (params) => {
  return axios.get(qz+"/api/BKProd/GetProdList?&mc="+params.mc+"&fl="+params.fl+"&fl2="+params.fl2+"&pageIndex=" +params.pageIndex+"&pageSize=" + params.pageSize)
    .then(res => res.data) };

export const prodListAuth = (params) => {
  return axios.get(qz+"/api/BKProd/GetPagedProdList?&mc="+params.mc+"&fl="+params.fl+"&fl2="+params.fl2+"&pageIndex=" +params.pageIndex+"&pageSize=" + params.pageSize,{
    headers:{
      'Authorization': `Bearer ${getStore("token")}`
    }
  })
    .then(res => res.data) };

export const prodListAdminAuth = (params) => {
  return axios.get(qz+"/api/BKProd/GetPagedProdListAdmin?&mc="+params.mc+"&fl="+params.fl+"&fl2="+params.fl2+
    "&pageIndex=" +params.pageIndex+"&pageSize=" + params.pageSize,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };


export const addProd = (params) => {
  return axios.post(qz+"/api/BKProd/AddProd",params,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const delProd = (params) => {
  return axios.post(qz+"/api/BKProd/DelProd?id="+params.id,params,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const prodInfo = (params) => {
  return axios.get(qz+"/api/BKProd/GetProdById?id="+params.id,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const prodInfo2 = (params) => {
  return axios.get(qz+"/api/BKProd/GetProdById?id="+params.id,{
    headers:{
      'Authorization': `Bearer ${getStore("token")}`
    }
  })
    .then(res => res.data) };

export const delFile = (params) => {
  return axios.post(qz+"/api/BKFile/RemoveFile?filePath="+params.filePath,params,{
    headers:{
      'Authorization': `Bearer ${getStore("tokenAdmin")}`
    }
  })
    .then(res => res.data) };

export const addCopyProd = (params) => {
  return axios.post(qz+"/api/BKProd/AddCopyProd?prodId="+params.prodId,params,{
    headers:{
      'Authorization': `Bearer ${getStore("token")}`
    }
  })
    .then(res => res.data) };



// WEBPACK FOOTER //
// ./src/api/bkProd.js